<template>
  <div />
</template>

<script>
import Hammer from "hammerjs";
import * as d3 from "d3";
import { ResizeObserver } from "@juggle/resize-observer";

export default {
  name: "TouchControls",
  props: { container: HTMLElement, truck: HTMLElement },
  data() {
    return {
      height: 175,
      width: 1000,
      hammertime: false
    };
  },
  mounted() {
    this.startHammer(this.container);

    const ro = new ResizeObserver(this.resize);
    ro.observe(this.$el);
    this.resizeObserver = ro;

    this.resize();
  },

  beforeDestroy() {
    this.resizeObserver.unobserve(this.$el);
    this.stopHammer();
  },

  methods: {
    stopHammer() {
      if (this.hammertime) {
        this.hammertime.stop();
        this.hammertime.destroy();
      }
    },

    startHammer(container) {
      if (!container) return;

      this.stopHammer();

      this.hammertime = new Hammer(container, {});

      let startLocation;

      this.hammertime.on("panstart", () => {
        startLocation = this.$store.state.geolocation.location;
      });

      this.hammertime.on("pan", ev => {
        let delta = this.scale.invert(ev.deltaX + this.width / 2);
        if (this.$store.state.geolocation.flipped) {
          delta *= -1;
        }
        this.$store.commit("setDirection", -1 * Math.sign(delta));
        this.$store.commit("setLocation", startLocation - delta);
      });

      this.hammertime.on("panend", ev => {
        let delta = this.scale.invert(ev.deltaX + this.width / 2);
        if (this.$store.state.geolocation.flipped) {
          delta *= -1;
        }
        if (Math.abs(delta) > 0.001) {
          this.$store.commit("accelerate", 100 * -1 * Math.sign(delta));
          setTimeout(() => this.$store.commit("accelerate", 0), 1000);
        }
      });
    },

    resize() {
      if (!this.container) return;
      this.width = this.container.clientWidth;
    }
  },

  computed: {
    scale() {
      let aspectRatio = this.width / this.height;

      return d3
        .scaleLinear()
        .domain([aspectRatio * 0.001, -0.001 * aspectRatio])
        .range([0, this.width]);
    }
  },

  watch: {
    container(to) {
      this.startHammer(to);
    }
  }
};
</script>
